// https://citrineinformatics.github.io/gemd-docs/specification/value-types/#molecular-structure
export interface IInChiValue {
  type: "inchi";
  inchi: string;
}

export const inChiValueToString = (inChiValue: IInChiValue): string => {
  // TODO might have to format this in a special way so it doesn't look like a plain string
  return inChiValue.inchi;
};
